/**
 * Admin — per-merchant payment method availability
 */
import api from './api';

export interface MerchantPaymentMethodItem {
  paymentMethodId: number;
  name: string;
  description?: string | null;
  type: string;
  icon?: string;
  platformIsActive: boolean;
  fee: number;
  feeDescription?: string | null;
  sortOrder?: number;
  isAvailable: boolean;
  isEnabledByMerchant: boolean;
}

function normalizeRow(raw: Record<string, unknown>): MerchantPaymentMethodItem {
  return {
    paymentMethodId: Number(
      raw.paymentMethodId ?? raw.payment_method_id ?? raw.id
    ),
    name: String(raw.name ?? ''),
    description: (raw.description as string) ?? null,
    type: String(raw.type ?? ''),
    icon: raw.icon as string | undefined,
    platformIsActive: Boolean(
      raw.platformIsActive ?? raw.platform_is_active ?? raw.is_active
    ),
    fee: Number(raw.fee ?? 0),
    feeDescription: (raw.feeDescription ?? raw.fee_description) as
      | string
      | null
      | undefined,
    sortOrder: Number(raw.sortOrder ?? raw.sort_order ?? 0),
    isAvailable: Boolean(raw.isAvailable ?? raw.is_available),
    isEnabledByMerchant: Boolean(
      raw.isEnabledByMerchant ?? raw.is_enabled_by_merchant ?? true
    ),
  };
}

export async function fetchMerchantPaymentMethods(
  merchantId: number | string
): Promise<MerchantPaymentMethodItem[]> {
  const res = await api.get<{
    success: boolean;
    data?: Record<string, unknown>[];
  }>(`/admin/merchants/${merchantId}/payment-methods`);
  if (!res.data.success || !res.data.data) return [];
  return res.data.data.map(row => normalizeRow(row));
}

export async function updateMerchantPaymentMethods(
  merchantId: number | string,
  methods: Array<{ paymentMethodId: number; isAvailable: boolean }>
): Promise<MerchantPaymentMethodItem[]> {
  const res = await api.put<{
    success: boolean;
    data?: Record<string, unknown>[];
  }>(`/admin/merchants/${merchantId}/payment-methods`, { methods });
  if (!res.data.success || !res.data.data) return [];
  return res.data.data.map(row => normalizeRow(row));
}

const TYPE_LABELS: Record<string, string> = {
  cash: 'Tiền mặt (COD)',
  momo: 'MoMo',
  zalopay: 'ZaloPay',
  card: 'Thẻ',
  bank: 'Chuyển khoản / VietQR',
  atm: 'Thẻ ATM',
};

export function paymentMethodTypeLabel(type: string): string {
  return TYPE_LABELS[type] ?? type;
}
